import { getAPI } from "./base";

// News Affecting Plans
export async function fetchNewsAffectingPlans(formValues) {
  try {
    // Validate required fields
    if (
      !formValues.country ||
      !formValues.sector ||
      !formValues.category ||
      !formValues.L2
    ) {
      return null;
    }

    const api = getAPI();

    var params = {
      Sector: formValues.sector,
      Category: formValues.category,
      L2: formValues.L2,
      L3: formValues.L3,
      L4: formValues.L4,
      Country: formValues.country,
    };

    // Validate optional fields
    if (formValues.L3) params.L3 = formValues.L3 || null;
    if (formValues.L4) params.L4 = formValues.L4 || null;

    const response = await api.get("/generateinsights/newsaffectingplans", {
      params,
    });

    if (response.status === 200) {
      return response.data;
    } else {
      console.error("Error fetching data: ", response.statusText);
    }
  } catch (error) {
    console.error("Error fetching data: ", error);
  }
}

// Size of Market
export async function fetchSizeOfMarket(formValues) {
  try {
    const api = getAPI();
    var params = {
      Category: formValues.category,
      Sector: formValues.sector,
      L2: formValues.L2,
      L3: formValues.L3,
      L4: formValues.L4,
      Analysistimeline: formValues.Analysistimeline,
      Region: formValues.region,
      Custom: formValues.custom,
      Country: formValues.country,
      Context: formValues.context || null,
    };

    const response = await api.get("/generateinsights/sizeofmarket", {
      params,
    });
    if (response.status === 200) {
      return response.data;
    } else {
      console.error("Error fetching data: ", response.statusText);
    }
  } catch (error) {
    console.error("Error fetching data: ", error);
    throw error;
  }
}

// Key challenges and trends
export async function fetchKeyChallengesAndTrends(formValues) {
  try {
    const api = getAPI();
    var params = {
      Category: formValues.category,
      Sector: formValues.sector,
      L2: formValues.L2,
      L3: formValues.L3,
      L4: formValues.L4,
      Country: formValues.country,
      Context: formValues.context || null,
    };

    const response = await api.get("/generateinsights/keyChallengesAndTrends", {
      params,
    });

    if (response.status === 200) {
      return response.data;
    } else {
      console.error("Error fetching data: ", response.statusText);
    }
  } catch (error) {
    console.error("Error fetching data: ", error);
    throw error;
  }
}

// Porter Five Forces
export async function fetchPorterFiveForces(formValues) {
  try {
    const api = getAPI();
    var params = {
      Category: formValues.category,
      L2: formValues.L2,
      L3: formValues.L3,
      L4: formValues.L4,
      Analysistimeline: formValues.Analysistimeline,
      Region: formValues.region,
      Country: formValues.country,
      Sector: formValues.sector,
      Context: formValues.context || null,
    };

    const response = await api.get("/generateinsights/porterfiveforces", {
      params,
    });
    if (response.status === 200) {
      return response.data;
    } else {
      console.error("Error fetching data: ", response.statusText);
    }
  } catch (error) {
    console.error("Error fetching data: ", error);
    throw error;
  }
}

// Regulations
export async function fetchRegulations(formValues) {
  try {
    const api = getAPI();
    var params = {
      Category: formValues.category,
      L2: formValues.L2,
      L3: formValues.L3,
      L4: formValues.L4,
      Sector: formValues.sector,
      Region: formValues.region,
      Country: formValues.country,
      Context: formValues.context || null,
    };

    const response = await api.get("/regulations", { params });
    if (response.status === 200) {
      return response.data;
    } else {
      console.error("Error fetching data: ", response.statusText);
    }
  } catch (error) {
    console.error("Error fetching data: ", error);
    throw error;
  }
}

// Accreditations
export async function fetchAccreditations(formValues) {
  try {
    const api = getAPI();
    var params = {
      Category: formValues.category,
      L2: formValues.L2,
      L3: formValues.L3,
      L4: formValues.L4,
      Sector: formValues.sector,
      Region: formValues.region,
      Country: formValues.country,
      Context: formValues.context || null,
    };

    const response = await api.get("/accreditations", {
      params: params,
    });
    if (response.status === 200) {
      return response.data;
    } else {
      console.error("Error fetching data: ", response.statusText);
    }
  } catch (error) {
    console.error("Error fetching data: ", error);
    throw error;
  }
}